import React, { Fragment, useContext, useEffect, useState } from 'react';
import "./Incluir.css";
import { LoadMask } from "../../../../Utils/mask";
import { validarCpf, validarCnpj } from '../../../../Utils/globalFunctions';
import { Listar as ListarFornecedoresLead } from '../../../../Services/FornecedorLead';
import { IncluirLead } from '../../../../Services/Lead';
import { ListarListBoxPorRotulo } from '../../../../Services/ListBox';
import { ListarSimples as ListarOrigensLead } from '../../../../Services/OrigemLead';
import { Listar as ListarProduto } from '../../../../Services/Produto';
import { Listar as ListarCatalogo } from '../../../../Services/Catalogo';
import { ListarSimples as ListarUsuario } from '../../../../Services/Usuario';
import {
	ObterInformacoesVeiculoPorPlaca
} from "../../../../Services/Auto";
import AppContext from '../../../../Store/AppContext';

const defaultData = {
	nomeCompleto: '',
	leadNumDocumento: '',
	dddTelefone: '',
	telefone: '',
	email: '',
	origem: '0',
	produtoId: '0',
	fornecedor: '0',
	leadConsultorId: '0',
	leadTipoNegocio: '',
	leadAuto: {
		leadAutoPlaca: '',
		leadAutoFabricante: '',
		leadAutoModelo: '',
		leadAutoAnoFabricacao: '',
		leadAutoAnoModelo: '',
	}
};

const Incluir = ({ conversaSelecionada = null, onClose = () => { } }) => {
	const { showLoading, hideLoading, showMessage, session } = useContext(AppContext);
	const [values, setValues] = useState(initialState(conversaSelecionada));
	LoadMask();


	function initialState(conversaSelecionada) {
		return {
			origensLeadApi: [],
			fornecedoresLeadApi: [],
			produtos: [],
			tiposNegocio: [],
			consultores: [],
			seguradoras: [],
			lead: {
				...defaultData,
				nomeCompleto: conversaSelecionada?.nome ?? '',
				dddTelefone: conversaSelecionada?.ddd ?? '',
				telefone: conversaSelecionada?.telefone ?? '',
				leadConsultorId: session.usuarioId
			}
		};
	}

	useEffect(() => {
		showLoading();
		async function carregarDependencias() {

			const [
				responseOrigensLead,
				responseFornecedoresLead,
				responseListarProduto,
				responseListarLeadTipoNegocio,
				responseListarUsuaro,
				responseListarCatalogo,
			] = await Promise.all([
				ListarOrigensLead(),
				ListarFornecedoresLead(),
				ListarProduto({}),
				ListarListBoxPorRotulo('LeadTipoNegocio'),
				ListarUsuario({}),
				ListarCatalogo({ catalogoRotulo: 'VAL_PADRAO_CAD_LEAD' }),

			]);

			let consultores = await responseListarUsuaro.usuarios.filter((usuario) => usuario.usuario_status !== 'A');

			let catalogos = responseListarCatalogo.catalogos;

			let origem = '0';
			let produtoId = '0';
			let fornecedor = '0';
			let leadTipoNegocio = '';

			if (catalogos.length > 0) {
				let valoresPadroes = catalogos[0];
				produtoId = valoresPadroes.catalogo001;
				origem = valoresPadroes.catalogo002;
				fornecedor = valoresPadroes.catalogo003;
				leadTipoNegocio = valoresPadroes.catalogo004;
			}


			setValues({
				...values,
				origensLeadApi: await responseOrigensLead.origensLead.filter((item) => item.origemLeadAtivo === 'A'),
				fornecedoresLeadApi: await responseFornecedoresLead.fornecedoresLead.filter((item) => item.fornecedorLeadAtivo === 'A'),
				produtos: await responseListarProduto.produtos.filter((item) => item.produtoAtivo === 'A'),
				tiposNegocio: await responseListarLeadTipoNegocio.items,
				consultores: consultores,
				lead: {
					...values.lead,
					origem: origem,
					produtoId: produtoId,
					fornecedor: fornecedor,
					leadTipoNegocio: leadTipoNegocio,
				}
			});
			hideLoading();
		}

		carregarDependencias();
	}, []);

	const formularioLeadComErro =
		!values.lead.nomeCompleto ||
		!values.lead.telefone ||
		!values.lead.dddTelefone ||
		!values.lead.email ||
		!values.lead.origem ||
		values.lead.origem === '0' ||
		!values.lead.fornecedor ||
		values.lead.fornecedor === '0' ||
		!values.lead.produtoId ||
		values.lead.produtoId === '0' ||
		!values.lead.leadConsultorId ||
		values.lead.leadConsultorId === '0';

	const formularioAutoComErro =
		values.lead.formularioAdicional === "LEADAUTO" &&
		(
			!values.lead.leadAuto?.leadAutoPlaca ||
			!values.lead.leadAuto?.leadAutoFabricante ||
			!values.lead.leadAuto?.leadAutoModelo ||
			!values.lead.leadAuto?.leadAutoAnoFabricacao ||
			!values.lead.leadAuto?.leadAutoAnoFabricacao === '0' ||
			!values.lead.leadAuto?.leadAutoAnoModelo ||
			!values.lead.leadAuto?.leadAutoAnoModelo === '0'
		);

	const formularioComErro = formularioLeadComErro || formularioAutoComErro;

	function onChangeInput(event) {
		const { name, value } = event.target;
		setValues({
			...values,
			lead: {
				...values.lead,
				[name]: value
			}
		});
	}


	function onChangeInputProduto(event) {
		const { name, value } = event.target;

		let formularioAdicional = null;
		if (value === '1') {
			formularioAdicional = "LEADAUTO";
		}

		setValues({
			...values,
			lead: {
				...values.lead,
				formularioAdicional,
				leadAuto: defaultData.leadAuto,
				[name]: value
			}
		});
	}

	function onChangeInputAuto(event) {
		const { name, value } = event.target;
		setValues({
			...values,
			lead: {
				...values.lead,
				leadAuto: {
					...values.lead.leadAuto,
					[name]: value
				}
			}
		});
	}

	function isValidLicensePlate(plate) {
		// Adjust the regex based on the format you need (this example supports Brazilian and North American plates)
		const plateRegex = /^[A-Z]{3}\d{4}$|^[A-Z]{3}\d[A-Z]\d{2}$/;
		return plateRegex.test(plate.toUpperCase());
	}

	function obterDadosVeiculoPorPlaca(event) {
		const { value } = event.target;
		if (isValidLicensePlate(value)) {
			obterInformacoesVeiculoPorPlaca(value);
		}
	}

	function obterInformacoesVeiculoPorPlaca(placa) {
		ObterInformacoesVeiculoPorPlaca(placa).then(async function (response) {
			if (response.success) {
				let informacoesVeiculoPorPlaca = response.informacoesVeiculoPorPlaca;

				setValues({
					...values,
					lead: {
						...values.lead,
						leadAuto: {
							...values.lead.leadAuto,
							leadAutoFabricante: informacoesVeiculoPorPlaca.marca,
							leadAutoModelo: informacoesVeiculoPorPlaca.modelo,
							leadAutoAnoFabricacao: informacoesVeiculoPorPlaca.anoFabricacao,
							leadAutoAnoModelo: informacoesVeiculoPorPlaca.anoModelo,
						}
					}
				});
			} else {
				showMessage("Alerta", response.message)
			}
		});
	}

	function onChangeInputCpfCnpj(event) {
		const { value } = event.target;
		var numeroDocumento = value;
		if (numeroDocumento == null) numeroDocumento = '';

		numeroDocumento = numeroDocumento.replace(/[/.-]/g, '');
		setValues({
			...values,
			lead: {
				...values.lead,
				leadNumDocumento: numeroDocumento
			}
		});
	}
	function validarDocumentoDigitado(event) {

		const { value } = event.target;
		var numeroDocumento = value;
		if (numeroDocumento == null) numeroDocumento = '';

		numeroDocumento = numeroDocumento.replace(/[.-]/g, '');
		if (!numeroDocumento) {
			return
		}
		if (numeroDocumento.length !== 11 && numeroDocumento.length !== 14) {
			showMessage('erro', 'Documento digitado esta no formato inválido.');
			setValues({
				...values,
				lead: {
					...values.lead,
					leadNumDocumento: ''
				}
			});
			return;
		}

		if (numeroDocumento.length === 11) {
			if (!validarCpf(numeroDocumento)) {
				showMessage('erro', 'Cpf Inválido.');
				setValues({
					...values,
					lead: {
						...values.lead,
						leadNumDocumento: ''
					}
				});
				return;
			}
		}
		if (numeroDocumento.length === 14) {
			if (!validarCnpj(numeroDocumento)) {
				showMessage('erro', 'Cnpj Inválido.');
				setValues({
					...values,
					lead: {
						...values.lead,
						leadNumDocumento: ''
					}
				});
				return;
			}
		}
	}


	const Incluir = async (lead) => {
		showLoading();
		const responseIncluirLead = await IncluirLead(lead);
		if (responseIncluirLead.success) {
			showMessage('Sucesso', 'Operação Realizada com Sucesso.');
			LimparFormulario();
		} else {
			showMessage('Erro', responseIncluirLead.message);
			if (responseIncluirLead.errors) {
				responseIncluirLead.errors.map((erro) => showMessage('Erro', erro.errorMessage));
			}
		}

		hideLoading();
	};

	const LimparFormulario = () => {
		setValues({
			...values,
			lead: defaultData,
		});
	};

	function salvar() {
		Incluir(values.lead);
		onClose();
	}

	return (
		<Fragment>
			<form>
				<div className="row">
					<div className="col-12">
						<div className="default-title"></div>
						<div className="card shadow-sm mb-4">
							<div className="row">
								<div className="col-12 col-md-6">
									<div className="form-group">
										<label>
											Nome Completo<span className="campoObratorio">*</span>
										</label>
										<input
											type="text"
											className="form-control uppercase"
											name="nomeCompleto"
											value={values.lead.nomeCompleto}
											onChange={onChangeInput}
										/>
									</div>
								</div>
								<div className="col-12 col-md-3 form-group">
									<label>
										CPF/CNPJ<span className="campoObratorio">*</span>
									</label>
									<input
										className="form-control"
										type="text"
										name="leadNumDocumento"
										value={values.lead.leadNumDocumento}
										onChange={onChangeInputCpfCnpj}
										onBlur={validarDocumentoDigitado}
									/>
								</div>
								<div className="col-12 col-md-1">
									<div className="form-group">
										<label>
											DDD
										</label>
										<input
											disabled={true}
											type="text"
											maxLength="2"
											className="form-control numerico"
											name="dddTelefone"
											value={values.lead.dddTelefone}
											onChange={onChangeInput}
										/>
									</div>
								</div>
								<div className="col-12 col-md-2">
									<div className="form-group">
										<label>
											Telefone
										</label>
										<input
											disabled={true}
											type="text"
											maxLength="9"
											className="form-control numerico"
											name="telefone"
											value={values.lead.telefone}
											onChange={onChangeInput}
										/>
									</div>
								</div>
								<div className="col-12 col-md-3">
									<div className="form-group">
										<label>
											Email<span className="campoObratorio">*</span>
										</label>
										<input
											type="email"
											className="form-control lowercase"
											name="email"
											value={values.lead.email}
											onChange={onChangeInput}
										/>
									</div>
								</div>


								<div className="col-12 col-md-3">
									<div className="form-group">
										<label>
											Tipo Negócio<span className="campoObratorio">*</span>
										</label>
										<select
											className="form-control"
											name="leadTipoNegocio"
											value={values.lead.leadTipoNegocio}
											onChange={onChangeInput}
										>
											<option className="disabled" value="" />
											{values.tiposNegocio.map((tipoNegocio) => (
												<option key={tipoNegocio.codigo} value={tipoNegocio.codigo}>
													{tipoNegocio.descricao}
												</option>
											))}
										</select>
									</div>
								</div>

								<div className="col-12 col-md-3 form-group">
									<label>
										Produto<span className="campoObratorio">*</span>
									</label>
									<select
										className="form-control"
										name="produtoId"
										value={values.lead.produtoId}
										onChange={onChangeInputProduto}
									>
										<option className="disabled" value="0" />
										{values.produtos.map((produto) => (
											<option key={produto.produtoId} value={produto.produtoId}>
												{produto.produtoNome}
											</option>
										))}
									</select>
								</div>

								<div className="col-12 col-md-3">
									<div className="form-group">
										<label >
											Origem<span className="campoObratorio">*</span>
										</label>
										<select
											className="form-control"
											name="origem"
											value={values.lead.origem}
											onChange={onChangeInput}
										>
											<option className="disabled" value="0" />
											{values.origensLeadApi.map((origem) => (
												<option key={origem.origemLeadId} value={origem.origemLeadId}>
													{origem.origemLeadNome}
												</option>
											))}
										</select>
									</div>
								</div>


								<div className="col-12 col-md-4">
									<div className="form-group">
										<label>
											Fornecedor<span className="campoObratorio">*</span>
										</label>
										<select
											className="form-control"
											name="fornecedor"
											value={values.lead.fornecedor}
											onChange={onChangeInput}
										>
											<option className="disabled" value="0" />
											{values.fornecedoresLeadApi.map((fornecedor) => (
												<option
													key={fornecedor.fornecedorLeadId}
													value={fornecedor.fornecedorLeadId}
												>
													{fornecedor.fornecedorLeadNome}
												</option>
											))}
										</select>
									</div>
								</div>


								<div className="col-12 col-md-3 form-group">
									<label>
										Consultor<span className="campoObratorio">*</span>
									</label>
									<select
										className="form-control"
										name="leadConsultorId"
										value={values.lead.leadConsultorId}
										onChange={onChangeInput}
									>
										<option className="disabled" value="0" />
										{values.consultores.map((usuario) => (
											<option key={usuario.usuarioId} value={usuario.usuarioId}>
												{usuario.usuarioNome}
											</option>
										))}
									</select>
								</div>


								{values.lead.formularioAdicional === "LEADAUTO" ?
									<Fragment>
										<div className="col-12"></div>
										<div className="col-12 col-md-2">
											<div className="form-group">
												<label>Placa<span className="campoObratorio">*</span></label>
												<input
													type="text"
													className="form-control placa_veiculo"
													name="leadAutoPlaca"
													maxLength="8"
													value={values.lead.leadAuto.leadAutoPlaca}
													onChange={onChangeInputAuto}
													onBlur={obterDadosVeiculoPorPlaca}
												/>
											</div>
										</div>
										<div className="col-12 col-md-3">
											<div className="form-group">
												<label>Veículo Marca<span className="campoObratorio">*</span></label>
												<input
													type="text"
													className="form-control uppercase"
													name="leadAutoFabricante"
													value={values.lead.leadAuto.leadAutoFabricante}
													onChange={onChangeInputAuto}
												/>
											</div>
										</div>
										<div className="col-12 col-md-3">
											<div className="form-group">
												<label>Veículo Modelo<span className="campoObratorio">*</span></label>
												<input
													type="text"
													className="form-control uppercase"
													name="leadAutoModelo"
													value={values.lead.leadAuto.leadAutoModelo}
													onChange={onChangeInputAuto}
												/>
											</div>
										</div>
										<div className="col-12 col-md-2">
											<div className="form-group">
												<label>Ano Fabricação<span className="campoObratorio">*</span></label>
												<input
													type="text"
													className="form-control numerico"
													name="leadAutoAnoFabricacao"
													maxLength="4"
													value={values.lead.leadAuto.leadAutoAnoFabricacao}
													onChange={onChangeInputAuto}
												/>
											</div>
										</div>
										<div className="col-12 col-md-2">
											<div className="form-group">
												<label>Ano Modelo<span className="campoObratorio">*</span></label>
												<input
													type="text"
													className="form-control numerico"
													name="leadAutoAnoModelo"
													maxLength="4"
													value={values.lead.leadAuto.leadAutoAnoModelo}
													onChange={onChangeInputAuto}
												/>
											</div>
										</div>
									</Fragment>
									: null
								}


							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-12 text-center">
						<button
							type="button"
							onClick={salvar}
							disabled={formularioComErro}
							className="btn btn-default"
						>
							Salvar
						</button>
					</div>
				</div>
			</form>
		</Fragment>
	);
};

export default Incluir;
